import { useState } from "react";
import React  from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
function ForgetPassowrd(){
const [email , setEmail] = useState('')
  const [error, setError] = useState([]);
  const handlerForgetPassword = async (e) => {
    e.preventDefault()
   try {
     const response = await  axios.post('https://trakersmallbusienss-3.onrender.com/api/auth/forgetPassword',
      {email}
    )
     Swal.fire({
            icon: 'success',
            title: 'An email has been sent to reset your password.',
            showConfirmButton: true,
               customClass: {
             confirmButton: 'my-swal-btn'
      }
          });
          setEmail(' ')
   } catch (error) {
     console.error('Login Error:', error);
         const errorMessages =
        error.response?.data?.errors ?? [{ msg: 'No user found with this email.' }];
    
          setError(errorMessages);
    
          Swal.fire({
            icon: 'error',
            title: 'Login Failed',
            html: errorMessages.map((e) => `<p>${e.msg}</p>`).join(''),
            customClass: {
             confirmButton: 'my-swal-btn'
      }
          });
   }

  }
    return(
         <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 card">
        <div>
          <h2 className="text-center text-3xl font-extrabold text-gray-900 dark:text-white">
            Forget My Password 
          </h2>
        </div>
       <form className="mt-8 space-y-6" onSubmit={handlerForgetPassword}>
          <div className="space-y-4">
            
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                Email address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-field mt-1"
              />
            </div>

          
          </div>

          <div>
            <button
              type="submit"
              className="w-full btn-primary"
            >
                Send
            </button>
          </div>

          <div className="text-center text-sm">
            <p className="text-gray-600 dark:text-gray-400">
              return Home ?{' '}
              <Link to="/" className="text-primary-600 dark:text-primary-400 hover:underline">
                Click Here
              </Link>
              

            </p>
          </div>
        </form>
        </div>
    </div>
    )
}

export default ForgetPassowrd 